import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog7postPostCatalogPublishResponseSchema = jsonObject
export type tcpcatalog7postPostCatalogPublishResponse = z.infer<typeof tcpcatalog7postPostCatalogPublishResponseSchema>
export const tcpcatalog7postPostCatalogRollbackResponseSchema = jsonObject
export type tcpcatalog7postPostCatalogRollbackResponse = z.infer<typeof tcpcatalog7postPostCatalogRollbackResponseSchema>
export const tcpcatalog7postPostCatalogImportPublishedResponseSchema = jsonObject
export const tcpcatalog7postPostCatalogPublishProposalsResponseSchema = jsonObject
export type tcpcatalog7postPostCatalogPublishProposalsResponse = z.infer<typeof tcpcatalog7postPostCatalogPublishProposalsResponseSchema>
export const tcpcatalog7postPostCatalogPublishProposalsIdConfirmResponseSchema = jsonObject
export type tcpcatalog7postPostCatalogPublishProposalsIdConfirmResponse = z.infer<typeof tcpcatalog7postPostCatalogPublishProposalsIdConfirmResponseSchema>
export const tcpcatalog7postGetCatalogPublishProposalsIdResponseSchema = jsonObject
export type tcpcatalog7postGetCatalogPublishProposalsIdResponse = z.infer<typeof tcpcatalog7postGetCatalogPublishProposalsIdResponseSchema>
export type tcpcatalog7postPostCatalogImportPublishedResponse = z.infer<typeof tcpcatalog7postPostCatalogImportPublishedResponseSchema>
